document.querySelectorAll('[data-fuzi-size-wrap]').forEach(function (wrap) {
  var trigger = wrap.querySelector('[data-fuzi-size-trigger]');
  var triggerText = wrap.querySelector('[data-fuzi-size-trigger-text]');
  var list = wrap.querySelector('[data-fuzi-size-list]');
  var form = wrap.closest('.fuzi-bs-form');
  if (!form) return;
  var hiddenInput = form.querySelector('.product-variant-id');
  var addBtn = form.querySelector('.fuzi-bs-pill-add');
  var info = form.closest('.fuzi-bs-info');
  var priceEl = info ? info.querySelector('[data-fuzi-bs-price]') : null;

  var isAutoScrolling = false;

  function closeList() {
    list.hidden = true;
    wrap.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function positionList() {
    var rect = trigger.getBoundingClientRect();
    list.style.left = rect.left + 'px';
    list.style.top = rect.bottom + 'px';
    list.style.width = rect.width + 'px';
  }

  function finishOpen() {
    positionList();
    list.style.visibility = '';
    wrap.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function openList() {
    // Reveal invisibly first so we can measure how tall the list actually
    // is (depends on the option count), without it flashing on screen.
    list.style.visibility = 'hidden';
    list.hidden = false;
    positionList();

    var overflow = list.getBoundingClientRect().bottom - window.innerHeight + 16;

    if (overflow > 0) {
      isAutoScrolling = true;
      window.scrollBy({ top: overflow, behavior: 'smooth' });

      var settleTimer = setTimeout(onSettled, 500);
      function onSettled() {
        clearTimeout(settleTimer);
        window.removeEventListener('scrollend', onSettled);
        isAutoScrolling = false;
        finishOpen();
      }
      window.addEventListener('scrollend', onSettled, { once: true });
    } else {
      finishOpen();
    }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    if (list.hidden) {
      openList();
    } else {
      closeList();
    }
  });

  // The list is position:fixed so it can escape the horizontally-clipped
  // carousel track; if the page or the track scrolls while it's open it
  // would visually detach from the trigger, so just close it instead of
  // trying to track two independent scroll positions live. The one
  // exception is the auto-scroll openList() triggers itself to bring a
  // clipped list into view, which must not immediately close it.
  window.addEventListener('scroll', function () {
    if (isAutoScrolling) return;
    if (!list.hidden) closeList();
  }, { passive: true, capture: true });
  window.addEventListener('resize', function () {
    if (!list.hidden) closeList();
  });

  list.querySelectorAll('[data-variant-id]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      if (opt.dataset.available !== 'true') return;

      triggerText.textContent = opt.dataset.title;
      hiddenInput.value = opt.dataset.variantId;
      hiddenInput.removeAttribute('disabled');

      if (priceEl && opt.dataset.price) {
        priceEl.textContent = opt.dataset.price;
      }

      addBtn.removeAttribute('disabled');
      var span = addBtn.querySelector('span');
      if (span) span.textContent = 'Add To Bag';

      list.querySelectorAll('.fuzi-bs-size-option').forEach(function (o) {
        o.classList.remove('is-selected');
      });
      opt.classList.add('is-selected');

      closeList();
    });
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) closeList();
  });
});

document.querySelectorAll('.fuzi-best-sellers-section').forEach(function (root) {
  var track = root.querySelector('.fuzi-bs-track');
  var prev = root.querySelector('[data-fuzi-bs-prev]');
  var next = root.querySelector('[data-fuzi-bs-next]');
  if (!track) return;

  function scrollByCard(direction) {
    var card = track.querySelector('.fuzi-bs-card');
    var gap = 32;
    var amount = card ? card.getBoundingClientRect().width + gap : 400;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  function updateArrows() {
    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    if (prev) prev.classList.toggle('is-disabled', x <= 2);
    if (next) next.classList.toggle('is-disabled', max <= 2 || x >= max - 2);
  }

  if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
  if (next) next.addEventListener('click', function () { scrollByCard(1); });

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
});
